/**
 * Prototype mini-dungeon: five ordinary encounters + final boss.
 * Rewards and enemy mixes are provisional placeholders (OPEN: balance).
 *
 * M7-B: encounter 4 includes an explicit elite template for equipment drops.
 * Boss chest flag remains; loot generation is difficulty-scaled in domain/loot.
 */

export interface EncounterBlueprint {
  id: string;
  /** Enemy template ids for this encounter, in action order. */
  enemyTemplateIds: readonly string[];
  /** Provisional gold granted when the encounter reward is collected. */
  rewardGold: number;
  /** Provisional crafting materials granted on reward collect. */
  rewardMaterials: number;
  /** True for the final boss encounter. */
  isBoss?: boolean;
  /** Boss chest present — equipment generated on collect (M7-B). */
  bossChestPlaceholder?: boolean;
}

export const MINI_DUNGEON_ID = 'proto_cave';

/** Display name for the first playable dungeon. */
export const MINI_DUNGEON_NAME = 'Proto Cave';

/**
 * Linear encounter sequence — no branching / exploration map.
 * Index 0..4 ordinary (+ one elite), index 5 boss.
 */
export const MINI_DUNGEON_ENCOUNTERS: readonly EncounterBlueprint[] = [
  {
    id: 'cave_1',
    enemyTemplateIds: ['bat'],
    rewardGold: 4,
    rewardMaterials: 1,
  },
  {
    id: 'cave_2',
    enemyTemplateIds: ['slime'],
    rewardGold: 6,
    rewardMaterials: 1,
  },
  {
    id: 'cave_3',
    enemyTemplateIds: ['bat', 'bat'],
    rewardGold: 8,
    rewardMaterials: 2,
  },
  {
    id: 'cave_4',
    enemyTemplateIds: ['elite_goblin'],
    rewardGold: 12,
    rewardMaterials: 3,
  },
  {
    id: 'cave_5',
    enemyTemplateIds: ['slime', 'goblin'],
    rewardGold: 14,
    rewardMaterials: 3,
  },
  {
    id: 'cave_boss',
    enemyTemplateIds: ['cave_brute'],
    rewardGold: 40,
    rewardMaterials: 8,
    isBoss: true,
    bossChestPlaceholder: true,
  },
] as const;

export const MINI_DUNGEON_ENCOUNTER_COUNT = MINI_DUNGEON_ENCOUNTERS.length;
